import Modal from 'react-modal';
import { USER_SIDE_PANEL, ROLE_SIDE_PANEL, INTERNAL_ROLE_SIDE_PANEL, ADMIN_USER_SIDE_PANEL, COMPANY_DETAILS_SIDE_PANEL } from '../../config/SidePanelTypes';
import PaymentTabs from './PaymentTabs/PaymentTabs';
import UserTabs from './UserTabs/UserTabs';
import RoleTab from './RoleTabs/RoleTab';
import './SidePanel.css';
import InternalRoleTab from './InternalRoleTabs/InternalRoleTab';
import AdminUserTabs from './UserTabs/AdminUserTabs';
import CompanyDetailsTab from './CompanyDetailsTabs/CompanyDetailsTab'

export default function SidePanel(props) {
    const { isModalOpen, setIsModalOpen, sidePanelType } = props;

    return (
        <Modal
            isOpen={isModalOpen}
            overlayClassName="efup-side-panel-overlay"
            className="efup-side-panel"
            onRequestClose={() => setIsModalOpen(false)}
        >

            {/* <!----------OFF CANVAS POP OUT----------> */}
            <div className="efup-side-panel-content" data-testid="efup-side-panel-content" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">

                <div className="offcanvas-header efup-side-panel-header">
                    {/* <!--TITLE for DESKTOP ONLY--> */}
                    <h3 id="offcanvasRightLabel" className="d-lg-block" data-testid="efup-side-panel-title" >
                        {sidePanelType === USER_SIDE_PANEL ? "User Details"
                            : sidePanelType === ROLE_SIDE_PANEL ? "Role Details"
                                : sidePanelType === INTERNAL_ROLE_SIDE_PANEL ? "Internal Role Details"
                                    : sidePanelType === ADMIN_USER_SIDE_PANEL ? "User Details"
                                        : sidePanelType === COMPANY_DETAILS_SIDE_PANEL ? "Company Details"
                                            : "Payment Details"}</h3>
                    <i
                        className="cb-icon icon-close efup-side-panel-close-icon"
                        alt="Close Button"
                        onClick={() => setIsModalOpen(false)}
                        tabIndex={0} onKeyDown={({ key }) => key === "Enter" ? setIsModalOpen(false) : ""}
                        data-testid="efup-side-panel-close-button"
                    />
                </div>
                {sidePanelType === USER_SIDE_PANEL ? <UserTabs uuid={props.userUuid} companyNumber={props.companyNumber} />
                    : sidePanelType === ROLE_SIDE_PANEL ? <RoleTab role={props.role} companyNumber={props.companyNumber} />
                        : sidePanelType === INTERNAL_ROLE_SIDE_PANEL ? <InternalRoleTab role={props.role} />
                            : sidePanelType === ADMIN_USER_SIDE_PANEL ? <AdminUserTabs uuid={props.userUuid} updateUser={props.updateUser} />
                                : sidePanelType === COMPANY_DETAILS_SIDE_PANEL ? <CompanyDetailsTab company={props.company} />
                                    : <PaymentTabs paymentUUID={props.paymentUUID} paymentType={props.paymentType} />
                }
            </div>
        </Modal>
    );
}